// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"2865105c","57":"01963e33","112":"24693ea2","152":"aae75893","232":"abf5ca71","405":"818da13a","437":"7a7f94e9","581":"4479de1a","648":"71d6cb8d","878":"b1834e82","994":"2ee0c0e1"}[chunkId] + ".chunk.js";
};